<template>
  <div v-if="isHydrated" class="customer-service-popup-wrapper">
    <div>
      <div class="consultant-desktop">
        <ConsultantPopupPC
          :position="position"
          :trigger="trigger"
          :debug-visible="debugVisible"
          :popup-container="popupContainer"
          :popup-visible="popupVisible"
          :scroll-to-close="scrollToClose"
          :scroll-to-close-distance="scrollToCloseDistance"
          @close="handleClose"
        >
          <template #trigger>
            <slot name="trigger"></slot>
          </template>
        </ConsultantPopupPC>
      </div>

      <div class="consultant-mobile">
        <ConsultantPopupMobile @close="handleClose">
          <template #trigger>
            <slot name="trigger"></slot>
          </template>
        </ConsultantPopupMobile>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import ConsultantPopupMobile from './ConsultantPopupMobile.vue'
import ConsultantPopupPC from './ConsultantPopupPC.vue'

const props = defineProps({
  position: {
    type: String,
    default: 'top',
    validator: (value) =>
      ['top', 'tl', 'tr', 'bottom', 'bl', 'br', 'left', 'lt', 'lb', 'right', 'rt', 'rb'].includes(
        value
      ),
  },
  trigger: {
    type: String,
    default: 'hover',
    validator: (value) => ['hover', 'click', 'focus'].includes(value),
  },
  debugVisible: {
    type: Boolean,
    default: false,
  },
  popupVisible: {
    type: Boolean,
    default: undefined,
  },
  popupContainer: {
    type: [String, Object],
    default: undefined,
  },
  scrollToClose: {
    type: Boolean,
    default: false,
  },
  scrollToCloseDistance: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['close'])

const isHydrated = ref(false)

const handleClose = () => {
  emit('close')
}

onMounted(() => {
  isHydrated.value = true
})
</script>

<style lang="scss" scoped>
.customer-service-popup-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.consultant-desktop {
  display: block;

  @include respond-to-max('lg') {
    display: none;
  }
}

.consultant-mobile {
  display: none;

  @include respond-to-max('lg') {
    display: block;
  }
}
</style>
